module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-square-text-fill-86ee54a0.svg";